import { BootstrapVue } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import App from "./App.vue";
import "./assets/css/custom.css";
import "./assets/css/style.css";
import router from "./router.js";


// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome' // eslint-disable-line
// import { fas, fad, fass, fasds } from '@awesome.me/kit-3aec4907e8/icons/modules' // eslint-disable-line

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
// import { all } from '@awesome.me/kit-3aec4907e8/icons/modules'
import { all } from '@awesome.me/kit-606ccc78fd/icons/modules'

/* add icons to the library */
// library.add(...all)
library.add(...all)

Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true;

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueClipboard);
Vue.use(BootstrapVue);
Vue.use(PerfectScrollbar);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
